import React, { useState, useEffect } from "react";
import { NavLink, Navigate, Link } from 'react-router-dom';
import { Eye, EyeOff, Loader2, CheckCircle2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { userService } from "../../_services";
import { stripTrackingFromUrl } from "../../utils/stripEmailTracking";
import SignupHeader from "../Register/signup_header";
import Signupleft from "../../images/signupleft.webp";
import signupcheck from "../../images/savecheck.png";

function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [resetsuccess, setResetsuccess] = useState(false);
    const [validateLink, setValidateLink] = useState(false);
    const [validationError, setValidationError] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({ Password_E: '', ConfirmPassword_E: '' });
    const [loginLoader, setLoginLoader] = useState(false);

    useEffect(() => {
        validatepwdresetlink(stripTrackingFromUrl(window.location.href), "1");
    }, []);

    const validatepwdresetlink = (requesturl, ObjectUid) => {
        try {
            userService.validatepwdresetlink(requesturl, ObjectUid)
                .then(apidata => {
                    if (apidata.length > 0) {
                        if (apidata[0].code !== "-1") {
                            setValidateLink(true);
                            setEmailAddress(apidata[0].email);
                        } else {
                            setValidationError(true);
                        }
                    }
                });
        } catch (error) {}
    };

    const updatepwd_bylink = (useremail, requesturl, pwd, confirmpwd) => {
        try {
            userService.updatepwd_bylink(useremail, requesturl, pwd, confirmpwd)
                .then(apidata => {
                    if (apidata.length > 0) {
                        if (apidata[0].code !== "-1") {
                            setLoginLoader(false);
                            setResetsuccess(true);
                        } else {
                            setLoginLoader(false);
                            setResetsuccess(false);
                        }
                    }
                });
        } catch (error) {}
    };

    const handleInput = (event) => {
        const { name, value } = event.target;
        if (name === 'Password') setPassword(value);
        else if (name === 'ConfirmPassword') setConfirmPassword(value);
        setErrors(prev => ({ ...prev, [name + '_E']: '' }));
    };

    const handle_second_signup = (event) => {
        event.preventDefault();
        const newErrors = { Password_E: '', ConfirmPassword_E: '' };
        if (password.length < 6) {
            newErrors.Password_E = 'Password must be at least 6 characters long';
        }
        if (password !== confirmPassword) {
            newErrors.ConfirmPassword_E = 'Password & Confirm Password must match!';
        }
        if (newErrors.Password_E || newErrors.ConfirmPassword_E) {
            setErrors(newErrors);
        } else {
            setLoginLoader(true);
            updatepwd_bylink(emailAddress, stripTrackingFromUrl(window.location.href), password, confirmPassword);
        }
    };

    if (!userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/Affiliate_Url" replace />;
    }

    return (
        <div className="min-h-screen bg-secondary">
            <SignupHeader />

            <div className="w-full mx-auto">
                <div className="flex items-center justify-center min-h-[calc(100vh-80px)]">
                    <div className="w-full max-w-[1260px] mx-auto px-4 md:px-8">
                        <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-16">
                            {/* Left side - Image */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[689px]">
                                <img
                                    src={Signupleft}
                                    alt="Reset your password"
                                    className="w-full h-auto object-contain"
                                />
                            </div>

                            {/* Right side - Form */}
                            <div className="flex-1 flex items-center justify-center md:max-w-[490px]">
                                <div className="w-full space-y-6">
                                    {validateLink ? (
                                        resetsuccess ? (
                                            /* Success state */
                                            <div className="text-center space-y-6">
                                                <div className="flex justify-center">
                                                    <div className="rounded-full bg-green-100 p-4">
                                                        <CheckCircle2 className="w-16 h-16 text-green-600" />
                                                    </div>
                                                </div>
                                                <div className="space-y-2">
                                                    <h2 className="text-3xl font-bold text-foreground">
                                                        Password Updated
                                                    </h2>
                                                    <p className="text-md text-foreground opacity-70">
                                                        Your password has been changed successfully.
                                                    </p>
                                                </div>
                                                <Button variant="secondary" size="lg" className="w-auto" asChild>
                                                    <NavLink to="/login">Sign In Now</NavLink>
                                                </Button>
                                            </div>
                                        ) : (
                                            /* Reset form */
                                            <>
                                                <div className="space-y-2 text-center md:text-left">
                                                    <h1 className="text-3xl md:text-4xl font-bold text-foreground">
                                                        Reset Password
                                                    </h1>
                                                    <p className="text-md text-foreground opacity-70">
                                                        Enter your new password below.
                                                    </p>
                                                </div>

                                                <form onSubmit={handle_second_signup} className="space-y-4">
                                                    {/* Password field */}
                                                    <div className="space-y-1">
                                                        <div className="relative">
                                                            <Input
                                                                type={showPassword ? 'text' : 'password'}
                                                                name="Password"
                                                                id="Password"
                                                                value={password}
                                                                maxLength={30}
                                                                onChange={handleInput}
                                                                placeholder=" "
                                                                className={`peer pr-10 h-12 ${errors.Password_E ? 'border-destructive' : ''}`}
                                                                disabled={loginLoader}
                                                            />
                                                            <Label
                                                                htmlFor="Password"
                                                                className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground pointer-events-none"
                                                            >
                                                                Password
                                                            </Label>
                                                            <Button
                                                                type="button"
                                                                size="icon"
                                                                variant="ghost"
                                                                onClick={() => setShowPassword(p => !p)}
                                                                className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 text-muted-foreground"
                                                            >
                                                                {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                                            </Button>
                                                        </div>
                                                        {errors.Password_E && (
                                                            <p className="text-sm text-destructive">{errors.Password_E}</p>
                                                        )}
                                                    </div>

                                                    {/* Confirm Password field */}
                                                    <div className="space-y-1">
                                                        <div className="relative">
                                                            <Input
                                                                type={showConfirmPassword ? 'text' : 'password'}
                                                                name="ConfirmPassword"
                                                                id="ConfirmPassword"
                                                                value={confirmPassword}
                                                                maxLength={30}
                                                                onChange={handleInput}
                                                                placeholder=" "
                                                                className={`peer pr-10 h-12 ${errors.ConfirmPassword_E ? 'border-destructive' : ''}`}
                                                                disabled={loginLoader}
                                                            />
                                                            <Label
                                                                htmlFor="ConfirmPassword"
                                                                className="absolute left-3 -top-2.5 bg-background px-1 text-sm text-foreground transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-base peer-placeholder-shown:text-muted-foreground peer-focus:-top-2.5 peer-focus:text-sm peer-focus:text-foreground pointer-events-none"
                                                            >
                                                                Confirm Password
                                                            </Label>
                                                            <Button
                                                                type="button"
                                                                size="icon"
                                                                variant="ghost"
                                                                onClick={() => setShowConfirmPassword(p => !p)}
                                                                className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 text-muted-foreground"
                                                            >
                                                                {showConfirmPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                                                            </Button>
                                                        </div>
                                                        {errors.ConfirmPassword_E && (
                                                            <p className="text-sm text-destructive">{errors.ConfirmPassword_E}</p>
                                                        )}
                                                    </div>

                                                    <Button
                                                        type="submit"
                                                        variant="secondary"
                                                        size="lg"
                                                        className="w-auto"
                                                        disabled={loginLoader}
                                                    >
                                                        {loginLoader
                                                            ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Saving...</>
                                                            : 'Save & Continue'
                                                        }
                                                    </Button>
                                                </form>
                                            </>
                                        )
                                    ) : (
                                        /* Link validation pending / error */
                                        <div className="text-center space-y-4">
                                            {!validationError ? (
                                                <p className="text-md text-foreground opacity-70">
                                                    Please wait, we are validating your link…
                                                </p>
                                            ) : (
                                                <>
                                                    <p className="text-md text-foreground font-medium">Link expired!</p>
                                                    <Link to="/signup" className="text-accent hover:text-foreground font-medium">
                                                        Sign Up here
                                                    </Link>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;

